import { useState, useEffect, useRef } from 'react';
import './Games.css';

export default function EnergyGame({ theme = 'default' }) {
    const [energy, setEnergy] = useState(0);
    const [taps, setTaps] = useState(0);
    const [level, setLevel] = useState(1);
    const [message, setMessage] = useState('');
    const decayRef = useRef(null);

    useEffect(() => {
        decayRef.current = setInterval(() => {
            setEnergy(prev => Math.max(0, prev - 2));
        }, 200);

        return () => clearInterval(decayRef.current);
    }, []);

    useEffect(() => {
        if (energy >= 100) {
            setLevel(prev => prev + 1);
            setEnergy(0);
            setMessage(`🎉 레벨 ${level + 1} 달성!`);
            setTimeout(() => setMessage(''), 1500);
        }
    }, [energy, level]);

    const handleTap = (e) => {
        e.preventDefault();
        setEnergy(prev => Math.min(100, prev + 10));
        setTaps(prev => prev + 1);
    };

    const themeClass = theme === 'daetong' ? 'theme-daetong' : theme === 'lighthouse' ? 'theme-lighthouse' : '';

    return (
        <div className={`game-container text-center ${themeClass}`}>
            <div className="game-title">✨ 탭해서 기운을 모으세요!</div>
            <div className="gauge-container">
                <div
                    className={`gauge-fill ${energy >= 100 ? 'full' : ''}`}
                    style={{ width: `${energy}%` }}
                />
            </div>

            <div
                className="tap-button"
                onClick={handleTap}
                onTouchEnd={handleTap}
            >
                ✨
            </div>

            <div className="game-stats">
                <span>레벨: {level}</span>
                <span>탭: {taps}회</span>
                <span>기운: {Math.floor(energy)}%</span>
            </div>

            <div className="game-message">{message}</div>
        </div>
    );
}
